module.exports = __webpack_public_path__ + "img/user.8fedb5a5.png";